import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { DateFilterComponent } from '../../shared/components/date-filter/date-filter.component';
import { ExcelService } from '../../shared/services/excel.service';
import { DateService } from '../../shared/services/date.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-ledgers',
  templateUrl: './ledgers.component.html',
  standalone: false,
  styleUrls: ['./ledgers.component.scss']
})
export class LedgersComponent {

  count = 0;
  showDateFilter = false;
  apiUrl: any;
  gridApi: any;
  selectedFromDate: any = null;
  selectedToDate: any = null;
  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Transaction Id',
      field: 'transactionId.createdAt',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Type',
      field: 'transactionType',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Source Bank',
      field: 'sourceBank',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Source Account',
      field: 'sourceAccount',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Destination Bank',
      field: 'destinationBank',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Destination Account',
      field: 'destinationAccount',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Currency',
      field: 'currency',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Amount',
      field: 'amount',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      cellRenderer: params => {
        if (params.value < 10) {
          return (params.value.toFixed(2));
        } else {
          return (params.value);
        }

      }
    },
  ];

  constructor(private _api: ApiService,
    private _excelService: ExcelService,
    private _dateService: DateService,
    private _auth: AuthService
  ) {
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    vm.gridApi.sizeColumnsToFit();
  }


  onSelectDate() {
    const vm = this;
    vm.showDateFilter = !vm.showDateFilter;
  }

  onDateSelected(result: any) {
    const vm = this;
    vm.selectedFromDate = result.fromDate;
    vm.selectedToDate = result.toDate;
    if (!vm.selectedFromDate && !vm.selectedToDate) {
      vm.showDateFilter = false;
    }
    if (vm.selectedFromDate || vm.selectedToDate) {
      vm.showDateFilter = false;
    }
    vm.gridApi.refreshInfiniteCache();
  }


  async onDownloadExcel() {
    const vm = this;
    const user = vm._auth.getUser();
    let downloadUrl = '/partners/auth/ledger?_page=1&_limit=500';
    if (vm.selectedFromDate && vm.selectedToDate) {
      downloadUrl += '&createdAtdatePickerRange=' + vm.selectedFromDate + ',' + vm.selectedToDate;
    }
    vm._api.getData(downloadUrl).subscribe(async (res: any) => {
      if (res && !res.error && res.data.length > 0) {
        const exportData = res.data.map((row) => ({
          'Transaction Id': row.transactionId?.createdAt
            ? vm._dateService.getFormattedDateWithAMPM(row.transactionId.createdAt) : '',
          'Type': row.transactionType || '',
          'Source Bank': row.sourceBank || '',
          'Source Account': row.sourceAccount || '',
          'Destination Bank': row.destinationBank || '',
          'Destination Account': row.destinationAccount || '',
          'Currency': row.currency || '',
          'Amount': row.amount != null ? (row.amount < 10 ? row.amount.toFixed(2) : row.amount) : ''
        }));
        await vm._excelService.exportAsExcelFile(exportData, 'Ledgers');
      }
    });
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
         const user = vm._auth.getUser();
         this.apiUrl = '/partners/auth/ledger?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });

        if (vm.selectedFromDate && vm.selectedToDate) {
          vm.apiUrl += '&createdAtdatePickerRange=' + vm.selectedFromDate + ',' + vm.selectedToDate;
        }
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

}

